function once(fn) {
    var promise;
    var hasRun = false;
    return function () {
        if (hasRun) {
            return promise;
        }
        promise = fn.apply(null, arguments);
        hasRun = true;
        return promise;
    };
}

function preferDefault(module) {
    return module.default ? module.default : module;
}

export { once, preferDefault };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@curi/helpers/dist/curi-helpers.es.js
// module id = 309
// module chunks = 0